import { Column, EditType } from '@src/model/table';
import { Dropdown } from './dropdown/dropdown';
import { IpInput } from './ip-input/ip-input';
import { AddressIPType } from '@src/utils/enums';
import { Address } from '@src/dtos/version.dto';
import { CustomInput } from '../custom-input/custom-input';
import { Radio } from 'antd';

interface EditControlProps<T> {
    type?: EditType;
    hasError?: boolean;
    column: Column<T>;
    value: any;
    placeholder?: string;
    disabled?: boolean;
    rowData: T;
    editProp: (accessor: string, value: any) => void;
}

export const TableEditControl = <T,>({
    type,
    column,
    value,
    placeholder,
    disabled,
    rowData,
    hasError,
    editProp
}: EditControlProps<T>) => {

    let input;
    const rowOptions = column.options?.(rowData);

    switch (type) {
        case EditType.Dropdown:
            if (rowOptions) {
                input = (
                    <Dropdown
                        accessor={column.accessor}
                        options={rowOptions}
                        editProp={editProp}
                        value={value}
                        placeholder={placeholder}
                        selectProps={{ ...column.selectProps, disabled }}
                    />
                );
            }
            break;
        case EditType.CustomDropdown:
            if (rowOptions) {
                input = (
                    <Dropdown
                        accessor={column.accessor}
                        infoContent={column.dropdownInfoContent}
                        options={rowOptions}
                        editProp={editProp}
                        value={value}
                        selectProps={{ ...column.selectProps, disabled }}
                    />
                );
            }
            break;
        case EditType.IP:
            input = (
                <IpInput
                    accessor={column.accessor}
                    editProp={editProp}
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    ipType={(rowData as Address).ipType || AddressIPType.IP_NETMASK}
                />
            );
            break;
        case EditType.TextArea:
            input = (
                <CustomInput inputType="TEXTAREA"
                    className={`${column.accessor}-textarea`}
                    placeholder={placeholder}
                    hideWarnMessage={hasError}
                    value={value}
                    maxLength={column.maxLength}
                    disabled={disabled}
                    onChange={(e) => editProp(column.accessor, e.target.value)}
                />
            );
            break;
        case EditType.RadioButton:
            input = <Radio.Group value={value}
                                 options={rowOptions}
                                 onChange={(e) => editProp(column.accessor, e.target.value)}
                                 disabled={disabled}>
            </Radio.Group>;
            break;
        default:
            input = (
                <CustomInput inputType="INPUT"
                    type="text"
                    hideWarnMessage={hasError}
                    className={`${column.accessor}-input`}
                    value={value}
                    onChange={(e) => editProp(column.accessor, e.target.value)}
                    placeholder={placeholder}
                    maxLength={column.maxLength}
                    disabled={disabled} />
            );
    }

    return (
        <span data-testid={`${column.accessor}-input`}>{input}</span>
    );
};
